import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const StatusBar = ({ zoomLevel, selectedObjectName, selectedObjectId, currentFloorName }) => {
  const { t } = useTranslation();
  const formattedZoom = zoomLevel ? (zoomLevel * 100).toFixed(0) : "N/A";
  
  let statusText;
  if (selectedObjectName === "drawing_instruction") {
      statusText = t('statusBar.drawing_instruction');
  } else if (selectedObjectName?.startsWith('Размещение:')) {
      const elementType = selectedObjectName.replace('Размещение: ', '').replace(/_/g, ' ');
      statusText = t('statusBar.placing', { elementType });
  } else if (selectedObjectName) {
      statusText = selectedObjectName;
  } else if (selectedObjectId) {
      statusText = t('statusBar.element_selected');
  } else {
      statusText = t('statusBar.ready');
  }
  
  return (
    <div className="p-2 bg-gray-100 border-t border-gray-300 text-sm text-gray-600 flex justify-between items-center px-4 flex-shrink-0">
      <span className="truncate max-w-[50%] min-w-[100px]">
        {currentFloorName ? `${currentFloorName} | ${statusText}` : statusText}
      </span>
      <span className="whitespace-nowrap ml-2">
        {currentFloorName && <span className="mr-3 pr-3 border-r border-gray-400 hidden sm:inline">{t('statusBar.floor')}: {currentFloorName}</span>}
        <span className="hidden sm:inline">Масштаб: </span>{formattedZoom}%
      </span>
    </div>
  );
};

StatusBar.propTypes = {
  zoomLevel: PropTypes.number,
  selectedObjectName: PropTypes.string,
  selectedObjectId: PropTypes.string,
  currentFloorName: PropTypes.string,
};

export default StatusBar;